const images = {
  underArrow: '/assets/components/CSelect/ic-cselect-under-arrow.png',
  selectDeleteBtn: '/assets/components/CSelect/ic-cselect-delete-btn.png',
};

export default images;
